<template>
  <PButton
    class="flex items-center justify-center rounded-full"
    :disabled="is_disabled || null"
    variant="outlined"
    :severity="[primary_color ? 'primary' : 'secondary']"
    :class="{ 'bg-white!': bg_white, 'self-stretch': self_stretch }"
    :size="size"
    @click.stop="submit"
  >
    <div
      v-if="iconFontawesome"
      class="icon flex items-center justify-center"
    >
      <FontAwesomeIcon :icon="iconFontawesome" />
    </div>
    <div v-if="!hide_text">
      <slot>{{ $t('button.actions.cancel') }}</slot>
    </div>
    <Badge
      v-if="badge_count"
      data-test="notifications-number"
      :value="badge_count"
    />
    <slot name="icon-right" />
  </PButton>
</template>

<script>
const ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  previous: 'chevron-left',
  next: 'chevron-right',
  create: 'plus',
  filter: ['far', 'bars-filter'],
  seen_by: ['far', 'eye'],
  shared_with: ['fas', 'users'],
  company: ['fas', 'building'],
  sign_out: 'right-from-bracket',
  upload: 'upload',
  help: ['far', 'circle-question'],
  sort: 'arrow-down-wide-short',
  collapse: 'chevron-up',
  expand: 'chevron-down',
  edit: ['far', 'pen-to-square'],
  lock: ['far', 'lock'],
  unlock: ['far', 'lock-open'],
  published: ['far', 'eye'],
  unpublish: ['far', 'eye-slash'],
  settings: ['far', 'sliders'],
  columns: ['far', 'columns-3'],
  add: ['far', 'plus'],
});

export default {
  dname: 'ButtonTertiary',

  props: {
    badge_count: { type: Number, default: null },
    is_disabled: { type: Boolean },
    action: {
      type: String,
      default: null,
      validator: (prop) => Object.keys(ACTIONS_TO_FONTAWESOME_ICON).includes(prop),
    },
    size: { type: String, default: 'small' },
    to: { type: Object, default: null },
    hide_text: { type: Boolean, default: false },
    bg_white: { type: Boolean, default: false },
    self_stretch: { type: Boolean, default: false },
    primary_color: { type: Boolean },
  },

  emits: ['onClick'],

  computed: {
    iconFontawesome() {
      return ACTIONS_TO_FONTAWESOME_ICON[this.action];
    },
  },

  methods: {
    submit(event) {
      if (this.is_disabled) return;
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$emit('onClick', event);
      }
    },
  },
};
</script>
